/* eslint-disable indent */
import Grid from '@elliemae/ds-grid';
import { styled, type Theme } from '@elliemae/ds-system';
import { DSLeftNavigationName, LEFT_NAVIGATION_SLOTS } from '../../constants/index.js';

interface ItemProps {
  selected: boolean;
  selectable: boolean;
  opened: boolean;
  theme: Theme;
  shadowStyle: (theme: Theme) => string;
}

export const borderOutside = (color: string, weight = 2): string => `&:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: ${weight}px solid ${color};
  pointer-events: none;
}`;

const getItemBackground = ({ selectable, opened, selected, theme }: ItemProps) => {
  if (!selectable) return 'white';
  if (selected && !opened) return theme.colors.brand[200];
  return theme.colors.neutral['000'];
};

const getItemHoverBackground = ({ selectable, opened, selected, theme }: ItemProps) => {
  if (!selectable) return 'white';
  if (selected && !opened) return theme.colors.brand[200];
  return theme.colors.brand['200'];
};

export const StyledItem = styled(Grid, { name: DSLeftNavigationName, slot: LEFT_NAVIGATION_SLOTS.ITEM })<
  { minHeight: string; selectedParent: boolean } & ItemProps
>`
  position: relative;
  cursor: ${(props) => (props.selectable && !props.opened ? 'pointer' : 'auto')};
  min-height: ${(props) => props.minHeight};

  background: ${getItemBackground};

  ${(props) => (props.selected && !props.opened ? borderOutside(props.theme.colors.brand[500], 1) : '')}

  :hover {
    background: ${getItemHoverBackground};
  }

  :active {
    background: ${({ selectable, theme }) => (selectable ? theme.colors.brand[200] : 'white')};
  }

  ${(props) => props.shadowStyle(props.theme)};

  outline: none;

  :focus {
    ${(props) => borderOutside(props.theme.colors.brand[700])}
  }
`;

export const StyledCollapsedContainer = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.COLLAPSED_CONTAINER,
})``;

export const StyledBorderBottom = styled('div', {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.ITEM_BORDER_BOTTOM,
})<{ opened: boolean; borderBottomMr?: string }>`
  margin-left: ${({ opened }) => (opened ? '12px' : '-4px')};
  margin-right: ${({ borderBottomMr }) => borderBottomMr};
  margin-top: 1px;
  height: 1px;
  width: calc(100% - ${({ borderBottomMr }) => borderBottomMr} - ${({ opened }) => (opened ? '12px' : '-4px')});
  background-color: #e0e3e8;
  grid-column: span 3;
  align-self: end;
`;
